import { render, staticRenderFns } from "./v-new-dialog.vue?vue&type=template&id=39486d38&scoped=true&"
import script from "./v-new-dialog.vue?vue&type=script&lang=js&"
export * from "./v-new-dialog.vue?vue&type=script&lang=js&"
import style0 from "./v-new-dialog.vue?vue&type=style&index=0&id=39486d38&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39486d38",
  null
  
)

export default component.exports